<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-8">
            <h5 class="card-title">Parcours & Elemente verwalten</h5>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <el-collapse accordion>
            <el-collapse-item :name="parc.key" v-for="parc in parcours" :key="parc.key">
              <template slot="title">
                <p class="pl-2 mt-3 text-uppercase" style="font-size: 1.1em;"><b>{{parc.parcoursName}}</b></p>
              </template>
              <div class="row pl-3">
                <div class="col-md-1 pb-3">
                  <span class="text-muted">Position</span>
                  <el-input
                    size="small"
                    type="number"
                    v-model="parc.parcoursPosition"
                    controls-position="right"
                  ></el-input>
                </div>
                <div class="col-md-5 pb-3">
                  <span class="text-muted">Name des Parcours</span>
                  <el-input
                    size="small"
                    style="text-align: center"
                    v-model="parc.parcoursName"
                    controls-position="right"
                  ></el-input>
                </div>
                <div class="col-md-2 pb-3">
                  <span class="text-muted">Durchschn. Höhe (m)</span>
                  <el-input-number
                    size="small"
                    style="text-align: center"
                    v-model="parc.parcoursHeight"
                    :min="0"
                    :max="40"
                    class="w-100"
                  ></el-input-number>
                </div>
              </div>
              <div class="row pt-4 pl-3 pb-2">
                <div class="col-md-12">
                  <h6>Plattformen & Elemente</h6>
                </div>
              </div>
              <div class="row pl-3 pb-2" v-if="parc.elements.length === 0">
                <div class="col-md-12">
                  <span class="text-muted">Es wurden keine Plattformen/Elemente zu diesem Parcours gefunden.</span>
                </div>
              </div>
              <div class="pl-3" v-for="element in parc.elements" :key="element.key" v-if="parc.elements.length > 0">
                <div class="row">
                  <div class="col-sm-1 pb-3">
                    <el-input
                      size="small"
                      type="number"
                      v-model="element.elementPosition"
                      controls-position="right"
                    ></el-input>
                  </div>
                  <div class="col-sm-5 pb-3">
                    <el-input
                      size="small"
                      style="text-align: center"
                      v-model="element.elementName"
                      controls-position="right"
                      placeholder="Name des Elements/Plattform"
                    ></el-input>
                  </div>
                  <div class="col-sm-3 pb-3">
                    <el-select
                      size="small"
                      v-model="element.elementType"
                      placeholder="Typ wählen"
                    >
                      <el-option
                        key="Plattform"
                        label="Plattform"
                        value="Plattform"
                      ></el-option>
                      <el-option
                        key="Element"
                        label="Element"
                        value="Element"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="col-sm-1 pr-4 pb-3">
                    <el-tooltip content="Element löschen" placement="top">
                      <p-button
                        class="my-0"
                        size="sm"
                        icon
                        @click="removeElement(parc.key, element.key, element.elementName)"
                      >
                        <i class="fa fa-trash"></i>
                      </p-button>
                    </el-tooltip>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-1 pb-3"></div>
                  <div class="col-sm-5 pb-3">
                    <el-input
                      type="textarea"
                      :rows="2"
                      size="small"
                      style="width: 100%;"
                      v-model="element.elementNote"
                      placeholder="Anmerkungen (optional)"
                    ></el-input>
                  </div>
                  <div class="col-sm-3 pb-3">
                    <label class="mr-2">Schlingenlänge (m)</label>
                    <el-input-number
                      :precision="2"
                      :max="4"
                      :step="0.25"
                      :min="0"
                      size="small"
                      style="text-align: center"
                      v-model="element.elementSchlinge"
                      controls-position="right"
                      placeholder="Schlingenlänge (m) (optional)"
                    ></el-input-number>
                  </div>
                  <div class="col-sm-1 pr-4 pb-3"></div>
                </div>
                <div class="row" v-for="check in element.elementChecks" :key="check.key">
                  <div class="col-sm-1 pb-1"></div>
                  <div class="col-sm-5 pb-1">
                    <el-input
                      size="small"
                      style="text-align: center"
                      controls-position="right"
                      v-model="check.checkText"
                      placeholder="Beschreibung des Prüfpunkts"
                    ></el-input>
                  </div>
                  <div class="col-sm-6 pr-4 pb-3">
                    <el-tooltip content="Check löschen" placement="top">
                      <p-button
                        class="my-0"
                        size="sm"
                        icon
                        @click="removeElementCheck(parc.key, element.key, check.key)"
                      >
                        <i class="fa fa-trash"></i>
                      </p-button>
                    </el-tooltip>
                  </div>

                </div>
                <div class="row pb-3">
                  <div class="col-sm-1"></div>
                  <div class="col-sm-11">
                    <p-button
                      size="sm"
                      @click="element.elementChecks.push({
                        key: generateUUID(),
                        checkText: '',
                      });"
                    >
                      <i class="fa fa-plus"></i> Check hinzufügen
                    </p-button>
                  </div>
                </div>
              </div>
              <div class="row pl-3 pb-3">
                <div class="col-md-12">
                  <p-button
                    type="primary"
                    size="md"
                    @click="editParcours(parc)"
                  >
                    <i class="fa fa-save"></i> Parcours speichern
                  </p-button>
                  <p-button
                    size="md"
                    @click="parc.elements.push({
                      key: generateUUID(),
                      elementPosition: parc.elements.length + 1,
                      elementName: '',
                      elementType: '',
                      elementChecks: [],
                      elementNote: '',
                      elementSchlinge: '',
                    });"
                  >
                    <i class="fa fa-plus"></i> Element hinzufügen
                  </p-button>
                  <p-button
                    type="danger"
                    size="md"
                    @click="removeParcours(parc.key, parc.parcoursName)"
                  >
                    <i class="fa fa-trash"></i> Parcours löschen
                  </p-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-8">
            <h5 class="card-title">Parcours hinzufügen</h5>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-8 pb-2">
              <div class="row">
                <div class="col">
                  <span class="text-muted">Name des Parcours</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <el-input
                    placeholder="Name des Parcours"
                    label="Parcours"
                    v-model="newParcours"
                  ></el-input>
                </div>
              </div>
            </div>
            <div class="col pb-2">
              <div class="row">
                <div class="col">
                  <span class="text-muted">Durchschn. Höhe (m)</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <el-input-number
                        style="text-align: center"
                        v-model="newHeight"
                        :min="0"
                        :max="40"
                  ></el-input-number>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="row">
            <div class="col">
              <p-button
                type="success"
                :disabled="newParcours == null || newHeight == 0"
                @click="addParcours()"
              ><i class="fa fa-plus"></i> Parcours hinzufügen</p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Tooltip, Select, Option, Input, InputNumber, Collapse, CollapseItem, MessageBox } from "element-ui";
import router from "../../../../main";
import store from "../../../../store";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);


export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    MessageBox,
  },

  data() {
    return {
      parcours: [],
      newParcours: null,
      newPos: 0,
      newHeight: 0,
      location: store.getters.userlocation,
      role: store.getters.userrole,
      constructionRole: store.getters.constructionRole,
    };
  },
  created() {
    if(store.getters.constructionRole < 4) {
      MessageBox.alert(
        "Zugriff verweigert.",
        {
          confirmButtonText: "OK",
          type: "error",
          callback: (action) => {
            router.push({ name: 'Overview' })
          },
        }
      );
    }
    this.loadParcours();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadParcours();
      }
    );
  },
  methods: {
    loadParcours() {
      const parcoursRef = db.collection("parcours");
      parcoursRef.where('locationID', '==', this.location).orderBy("position").onSnapshot((snapshotChange) => {
        this.parcours = [];
        snapshotChange.forEach((doc) => {
          const elements = [];
          // Fetch elements for each parcours from subcollection 'elements'
          const elementsRef = parcoursRef.doc(doc.id).collection("elements");
          elementsRef.orderBy("elementPosition").get().then((elementsSnapshot) => {
            
            elementsSnapshot.forEach((elementDoc) => {
              elements.push({
                key: elementDoc.id,
                elementPosition: elementDoc.data().elementPosition,
                elementName: elementDoc.data().elementName,
                elementType: elementDoc.data().elementType,
                elementNote: elementDoc.data().elementNote || '',
                elementSchlinge: elementDoc.data().elementSchlinge || '',
                elementChecks: elementDoc.data().elementChecks || [],
              });
            });
          });
          this.parcours.push({
            key: doc.id,
            parcoursName: doc.data().Name,
            parcoursPosition: doc.data().position,
            parcoursHeight: doc.data().height || 0,
            elements: elements
          });
        });
      });
    },
    removeParcours(parcKey, parcName) {
      MessageBox.confirm(
        "Soll der Parcours " + parcName + " wirklich gelöscht werden?",
        "Warnung",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              db.collection("parcours").doc(parcKey).delete().then(() => {
                console.log("Parcours " + parcName + " removed.");
                this.loadParcours()
              }).catch(() => {
                console.log("Error removing parcours.");
              });
            }
          },
        }
      );
    },
    removeElement(parcKey, elementKey, elementName) {
      MessageBox.confirm(
        "Soll das Element " + elementName + " wirklich gelöscht werden?",
        "Warnung",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              db.collection("parcours").doc(parcKey).collection("elements").doc(elementKey).delete().then(() => {
                console.log("Element " + elementName + " removed.");
                this.loadParcours()
              }).catch(() => {
                console.log("Error removing element.");
              });
            }
          },
        }
      );
    },
    removeElementCheck(parcKey, elementKey, elementName) {
      MessageBox.confirm(
        "Soll der Checkpunkt wirklich gelöscht werden?",
        "Warnung",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              db.collection("parcours").doc(parcKey).collection("elements").doc(elementKey).get().then((doc) => {
                if (doc.exists) {
                  let checks = doc.data().elementChecks || [];
                  checks = checks.filter(check => check.key !== elementName);
                  db.collection("parcours").doc(parcKey).collection("elements").doc(elementKey).update({
                    elementChecks: checks
                  }).then(() => {
                    console.log("Checkpoint removed.");
                    this.loadParcours()
                  }).catch(() => {
                    console.log("Error removing checkpoint.");
                  });
                }
              });
            }
          },
        }
      );
    },
    addParcours() {
      this.newPos =
        Math.max.apply(
          Math,
          this.parcours.map(function (obj) {
            return obj.parcoursPosition;
          })
        ) + 1;
      if (this.newPos === -Infinity) {
        this.newPos = 1;
      }
      db.collection("parcours")
        .add({
          Name: this.newParcours,
          position: this.newPos,
          locationID: this.location,
          height: this.newHeight
        })
        .then(() => {
          this.newParcours = null;
          this.newPos = 0;
          this.newHeight = 0;
          console.log("Parcours added.");
        })
        .catch(() => {
          console.log("Adding parcours failed");
        });
    },
    editParcours(parc) {
      console.log("Editing parcours: ", parc.parcoursName);
      console.log("hight: ", parc.parcoursHeight);
      db.collection("parcours")
        .doc(parc.key)
        .update({
          Name: parc.parcoursName,
          position: parseInt(parc.parcoursPosition),
          height: parseInt(parc.parcoursHeight),
        })
        .then(() => {
          console.log("Parcours updated.");
          for (let element of parc.elements) {
            db.collection("parcours")
              .doc(parc.key)
              .collection("elements")
              .doc(element.key)
              .set({
                elementPosition: parseInt(element.elementPosition),
                elementName: element.elementName,
                elementType: element.elementType,
                elementNote: element.elementNote || '',
                elementSchlinge: element.elementSchlinge || '',
                elementChecks: element.elementChecks || [],
              })
              .then(() => {
                console.log("Element updated: ", element.elementName);
              })
              .catch((error) => {
                console.log("Error updating element " + error);
              });
          }
          this.loadParcours();

        })
        .catch((error) => {
          console.log("Error updating parcours " + error);
        });
    },
    generateUUID() {
      // generate a unique identifier without crypto
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
  },
};
</script>
<style>
</style>
